

// 实现一键复制文本内容，用于鼠标右键粘贴。
export default {
  bind(el) {
    el.style.animation = "shake 0.82s cubic-bezier(.36,.07,.19,.97) both";
    el.addEventListener("animationend", () => {
      el.style.animation = "";
    });
  },
};
